<div
  class="service--banner font-14 d-flex align-items-center justify-content-between gap-2 p-2"
>
  <div class="d-flex gap-2 align-items-center">
    <img src="/assets/img/favicon.png" width="16" height="16" />
    <span>{{ "common.installPrompt" | translate }}</span>
  </div>
  <div class="d-flex gap-3 align-items-center">
    <button
      class="btn btn-primary py-0 px-3"
      (click)="pwaInstallService.install()"
    >
      {{ "common.install" | translate }}
    </button>
    <div
      class="box--close d-flex align-items-center justify-content-center rounded-3 text-black"
      (click)="pwaInstallService.dismiss()"
    >
      <i class="bi bi-x"></i>
    </div>
  </div>
</div>
